import * as React from "react";
import {DynamicWorkerServiceResource} from "../../client/resources/dynamicWorkerServiceResource";

function buildDynamicWorkerServiceBreadcrumbTitle(service?: DynamicWorkerServiceResource) {
        return service ?  `${service.Name} (${service.Id})` : "not available";
}


export default buildDynamicWorkerServiceBreadcrumbTitle;